import React from 'react';
import { GetStaticPropsContext } from "next";
import { createSubscription } from "components/hooks/usePreview";
import { withAppLayout } from "components/core/withAppLayout";
import { getEventsPage } from "queries/Events";
import TextBlock, { ITextBlock } from "blocks/text/TextBlock";
import CtaBlock, { ICtaBlock } from "blocks/cta/CtaBlock";
import useRouter from "components/hooks/useRouter";
import Container from "components/core/Container";
import LanguageSwitcher from "components/base/LanguageSwitcher";
import Link from "components/base/Link";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../../next-i18next.config";
import useTrans from "components/hooks/useTrans";

export async function getStaticProps(context: GetStaticPropsContext) {
    const query = {
        query: getEventsPage(context.locale),
        preview: context.preview,
        withAppData: true,
        locale: context.locale
    };

    const data = await createSubscription(context, query);

    return {
        props: {
            data: data,
            seo: data.initialData.eventsPage.seo,
            appData: {
                ...data.initialData.header,
                ...data.initialData.footer,
            },
            ...(await serverSideTranslations(context.locale, ['common'], nextI18NextConfig)),
        }
    };
}


type Props = {
    eventsPage: {
        content: ITextBlock,
        cta: ICtaBlock
    }
};

function Live({ eventsPage }: Props) {
    const textBlock = eventsPage.content[0];
    const cta = eventsPage.cta;
    const { t } = useTrans();
    const { locale } = useRouter();

    return (
        <>
            <section className={"w-full"}>
                <TextBlock {...textBlock} />
            </section>
            <section>
                <Container>
                    <div className={"w-full mb-20"}>
                        <ul className={"flex flex-row justify-center"}>
                            <li className={"text-xl text-purple-dark opacity-50  border-r-2 pr-5 border-purple-tint hover:underline hover:text-purple hover:opacity-100"}>
                                <Link to={"/events"}>{t('onDemandEvents')}</Link>
                            </li>
                            <li className={"text-xl text-purple underline pl-5 hover:underline hover:text-purple hover:opacity-100"}>
                                <Link to={"/events/live"} className={""}>{t('liveEvents')}</Link>
                            </li>
                        </ul>
                    </div>
                </Container>
            </section>
            <section>
                <Container>
                    <div className={"w-full flex justify-end pb-5 px-5"}>
                        <LanguageSwitcher size={"large"} />
                    </div>
                    <div>
                        <iframe
                            width="100%"
                            height="800"
                            frameBorder="0"
                            src={`https://app.livestorm.co/piggy-loyalty-b-v/upcoming?upcoming_locale=${locale}&limit=20`}
                            title="Live events | Livestorm"
                        />
                    </div>
                </Container>
            </section>
            <section>
                <CtaBlock {...cta} />
            </section>
        </>
    );
}

export default withAppLayout(Live);